import React from 'react';

export default function Video(props) {
  let asset = props.asset;

  let sources = [...asset.sources].map((source, index) => {
    return <source id={source.type} key={`${source.type}_${index}`} src={source.url} type={`video/${source.type}`} />
  })

  return <video className="djs-project__media-asset" controls preload="none" mediaGroup={asset.id} poster={asset.poster}>
  {sources}
  <p>Unfortunately, it appears that your browser does not support the HTML5 Video element.</p>
</video>;
}



// WEBPACK FOOTER //
// ./src/components/Assets/Video.js